import SectionHead from '../components/SectionHead';
import Reveal from '../components/Reveal';
import InquiryForm from '../components/InquiryForm';
import { CONTACT } from '../content/site';
import usePageMeta from '../hooks/usePageMeta';

export default function Quote() {
  usePageMeta(
    'Request a Consultation | RangeSafe Commercial Solutions',
    'Request a consultation for RangeSafe stove safety knobs: portfolio pricing, pilot programs and compatibility guidance from the Commercial Solutions Team.'
  );
  return (
    <main className="pt-16">
      <header className="mx-auto max-w-shell px-5 pb-14 pt-20 sm:px-8 lg:pt-28">
        <SectionHead
          as="h1"
          eyebrow="Commercial Inquiry"
          lines={['Request a', 'Consultation']}
          lead="The RangeSafe Commercial Solutions Team responds with product guidance, compatibility review and quote-based pricing."
        />
      </header>

      <div className="mx-auto max-w-shell px-5 pb-24 sm:px-8">
        <Reveal>
          <div className="border border-line bg-panel/40 p-6 sm:p-10 lg:p-12" data-testid="quote-form-panel">
            <p className="max-w-2xl text-base leading-relaxed text-neutral-200" data-testid="quote-form-intro">
              Share your contact details and our Commercial Solutions Team will help you find the right products and
              pricing. No quantities or product selection initially required.
            </p>

            <div className="mt-6 grid gap-12 lg:grid-cols-2 lg:gap-16">
              <div>
                <InquiryForm type="quote" submitLabel="Request a Consultation" simple />
              </div>

              <div className="space-y-8 lg:border-l lg:border-line lg:pl-16">
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-mute">What happens next</p>
                  <ol className="mt-5 space-y-4 border-t border-line2 pt-5 text-sm leading-relaxed text-dim">
                    <li className="flex gap-3"><span className="font-mono text-[10px] text-accentText">01</span>Your inquiry is routed to the RangeSafe Commercial Solutions Team.</li>
                    <li className="flex gap-3"><span className="font-mono text-[10px] text-accentText">02</span>The team reviews your problem, appliances and required quantities.</li>
                    <li className="flex gap-3"><span className="font-mono text-[10px] text-accentText">03</span>You receive product guidance, quote-based pricing and, if applicable, product samples and a pilot option.</li>
                  </ol>
                </div>

                <div className="border-t border-line pt-6">
                  <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-mute">Direct contact</p>
                  <p className="mt-4 font-mono text-sm text-white">
                    <a href={`mailto:${CONTACT.commercialEmail}`} className="hover:text-accent2" data-testid="quote-email">{CONTACT.commercialEmail}</a>
                  </p>
                  <p className="mt-1 font-mono text-sm text-white">
                    <a href={CONTACT.phoneHref} className="hover:text-accent2" data-testid="quote-phone">{CONTACT.phone}</a>
                  </p>
                </div>

                <p className="border-t border-line pt-6 text-xs leading-relaxed text-mute">
                  Pricing is quote-based — no volume pricing, minimums or delivery times are published
                  in advance. Your inquiry details go only to the RangeSafe Commercial Solutions Team.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </main>
  );
}
